import su from './sub.module.scss';

export default function SubmitBtn2({ label, onClick }) {
  return (
    <>
      <input type="submit" className={su.in} value={label} onClick={onClick} />
    </>
  );
}
 

export  function SubmitBtn3({ label, onClick, loading, type }) {
  return (
    <button className={su.in2} disabled={loading||false} type={type||"submit"} onClick={onClick}>
   	{loading?<div className={su.loader}></div>:<>{label}</>} 
   	
    </button>
  );
}
 